import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Filters, ProductList, Sort, Layout } from '../components'
import { useFilterContext } from '../context/filter_context'

const PageHeroHeader = styled.header`
  background: #fff;
  padding: 3rem 0 2rem 0;
  text-align: left;
  width: 100%;
  margin-bottom: 0;
`;

const PageHeroTitle = styled.h1`
  color: #F87B15;
  font-size: 2.5rem;
  font-weight: 800;
  margin: 0 0 0 3rem;
  font-family: 'Nunito', sans-serif;
`;

const ProductsPage = () => {
  const { clearFilters, isClickFromServices, resetIsClickFromServices } =
    useFilterContext()

  useEffect(() => {
    if (isClickFromServices) {
      // if this page mounts because clicking a button in Services, should not run clearFilters()
      // no set time out is needed to reset the variable
      resetIsClickFromServices()
    } else {
      // when component mounts clear the filter
      clearFilters()
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Layout showCommonFooter>
      <PageHeroHeader>
        <PageHeroTitle>Products</PageHeroTitle>
      </PageHeroHeader>
      <Wrapper className='page'>
        <div className='section-center products'>
          <Filters />
          <div>
            <Sort />
            <ProductList />
          </div>
        </div>
      </Wrapper>
    </Layout>
  )
}

const Wrapper = styled.div`
  .products {
    display: grid;
    gap: 3rem 1.5rem;
    margin: 4rem auto;
  }
  @media (min-width: 768px) {
    .products {
      grid-template-columns: 200px 1fr;
    }
  }
`

export default ProductsPage
